var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"tick",attrs:{"viewBox":"0 0 32 32"}},[_c('path',{attrs:{"d":"M27 4l-15 15-7-7-5 5 12 12 20-20z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }